var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.step && _vm.step < _vm.stepCount)?_c('span',{staticClass:"Progress Progress--small mb-5 col-2 mx-auto"},[_c('span',{staticClass:"bg-blue",style:(("width: " + (parseInt((100 / _vm.stepCount) * _vm.step)) + "%;"))})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }